import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../src/views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/contato',
      name: 'contato',
      component: () =>
      import(
        /* webpackChunkName: "Contato" */ '../src/views/FormContact.vue'
      )
    },
    {
      path: "/cpa",
      name: "cpa",
      meta: {
        title: "cpa"
      },
      component: () =>
        import("../src/views/cpa/HomeCPA.vue")
    },
  
    {
      path: "/cpa/noticias",
      name: "noticias",
      meta: {
        title: "noticias"
      },
      component: () =>
        import("../src/views/cpa/NoticiasCPA.vue")
    },
  
    {
      path: "/cpa/membros",
      name: "membros",
      meta: {
        title: "membros"
      },
      component: () =>
        import("../src/views/cpa/MembrosCPA.vue")
    },
  
    {
      path: "/cpa/documentos",
      name: "documentoscpa",
      meta: {
        title: "documentoscpa"
      },
      component: () =>
        import("../src/views/cpa/DocumentosCPA.vue")
    },
  
    {
      path: "/cpa/legislacao",
      name: "legislacao",
      meta: {
        title: "legislacao"
      },
      component: () =>
        import("../src/views/cpa/LegislacaoCPA.vue")
    },
  
    {
      path: "/cpa/relato-institucional",
      name: "relato-institucional",
      meta: {
        title: "relato-institucional"
      },
      component: () =>
        import("../src/views/cpa/RelatoInstitucionalCPA.vue")
    },
  
    {
      path: "/cpa/painel-de-avaliacoes",
      name: "painel-de-avaliacoes",
      meta: {
        title: "painel-de-avaliacoes"
      },
      component: () =>
        import("../src/views/cpa/PainelAvaliacoesCPA.vue")
    },
  
    {
      path: "/cpa/auto-avaliacao-acesso",
      name: "auto-avaliacao-institucional",
      meta: {
        title: "auto-avaliacao-institucional"
      },
      component: () =>
        import("../src/views/cpa/AutoAvaliacaoCPA.vue")
    },
  
    {
      path: "/cpa/avaliacaocpa",
      name: "avaliacaocpa",
      meta: {
        requiresAuth: true,
        title: "avaliacaocpa"
      },
      component: () =>
        import("../src/views/cpa/AvaliacaoInstitucionalCPA.vue")
    },
  
    {
      path: "/cpa/avaliacaoegresso",
      name: "avaliacaoegresso",
      meta: {
        requiresAuth: true,
        title: "avaliacaoegresso"
      },
      component: () =>
        import("../src/views/cpa/AvaliacaoEgressoCPA.vue")
    },
  
    {
      path: "/cpa/avaliacaocolegiado",
      name: "avaliacaocolegiado",
      meta: {
        requiresAuth: true,
        title: "avaliacaocolegiado"
      },
      component: () =>
        import("../src/views/cpa/AvaliacaoColegiadoCPA.vue")
    },
  
    {
      path: "/cpa/avaliacaocoordenador",
      name: "avaliacaocoordenador",
      meta: {
        requiresAuth: true,
        title: "avaliacaocoordenador"
      },
      component: () =>
        import("../src/views/cpa/AvalicaoCoordenadorCPA.vue")
    },
  
    {
      path: "/cpa/cadastrocpa",
      name: "cadastrocpa",
      meta: {
        requiresAuth: true,
        title: "cadastrocpa"
      },
      component: () =>
        import("../src/views/cpa/CadastroCPA.vue")
    },
  
    {
      path: "/cpa/tokencpa",
      name: "tokencpa",
      meta: {
        requiresAuth: true,
        title: "tokencpa"
      },
      component: () =>
        import("../src/views/cpa/TokenCPA.vue")
    },
    {
      path: '/validar',
      name: 'validar',
      component: () =>
      import(
        '../src/views/ValidacaoDiploma.vue'
      )
    },
    {
      path: '/contrato',
      name: 'contrato',
      component: () =>
      import(
        '../src/views/VisualizarContrato.vue'
      )
    },    
    {
      path: "/documentosInstitucionais",
      name: "Documentos Institucionais",
      meta: {
        title: "Documentos Institucionais"
      },
      component: () =>
        import("../src/views/ListagemDocumento.vue")
    },
    {
      path: "/acessibilidade",
      name: "acessibilidade",
      // meta: {
      //   title: "Acessibilidade"
      // },
      component: () =>
        import("../src/views/AcessibilidadeList.vue")
    },
    {
      path: "/brinquedoteca",
      name: "brinquedoteca",
      meta: {
        title: "Brinquedoteca"
      },
      component: () =>
        import("../src/views/BrinquedotecaList.vue")
    },
    {
      path: "/requerimentos",
      name: "requerimentos",
      meta: {
        title: "Requerimentos"
      },
      component: () =>
        import("../src/views/Requerimentos/BuscarRequerimento.vue")
    },
    {
      path: "/novo-requerimento",
      name: "requerimento-outros",
      meta: {
        title: "Novo Requerimento"
      },
      component: () =>
        import("../src/views/Requerimentos/NovoRequerimento.vue")
    },
    {
      path: "/historico-requerimento",
      name: "historico",
      meta: {
        title: "Novo Requerimento"
      },
      component: () =>
        import("../src/views/Requerimentos/HistoricoRequerimento.vue")
    },
    {
      path: "/acesso",
      name: "validacao-Acesso",
      meta: {
        title: "Validação Acesso"
      },
      component: () =>
        import(/* webpackChunkName: "acesso" */ "../src/views/ValidacaoAcesso.vue")
    },
    {
      path: "/baixarArquivos",
      name: "Arquivos para baixar",
      meta: {
        title: "Arquivos para baixar"
      },
      component: () =>
        import(/* webpackChunkName: "Listagem documento" */ "../src/views/BaixarArquivos.vue")
    },
    {
      path: "/documento",
      name: "documento",
      meta: {
        title: "Documentos"
      },
      component: () =>
        import(/* webpackChunkName: "Documentos" */ "../src/views/DocumentoList.vue")
    },
    {
    path: "/secretaria/login",
    name: "secretaria-login",
    meta: {
      title: "Login Secretaria"
    },
    component: () =>
      import(/* webpackChunkName: "Login Secretaria" */ "../src/views/Secretaria/SecretariaLogin.vue")
  },
  {
    path: "/secretaria",
    name: "secretaria",
    meta: {
      title: "Secretaria Painel"
    },
    component: () =>
      import(/* webpackChunkName: "Secretaria" */"../src/views/Secretaria/SecretariaPainel.vue")
  },
  {
    path: "/declaracao",
    name: "declaracao",
    meta: {
      title: "Declaracao"
    },
    component: () =>
      import(/* webpackChunkName: "Declaracao" */"../src/views/DeclaracaoList.vue")
  },
  {
    path: "/biblioteca",
    name: "biblioteca-digital",
    meta: {
      title: "Biblioteca Digital"
    },
    component: () =>
      import("../src/views/MinhaBiblioteca.vue")
  },
  {
    path: "/portal-do-aluno",
    name: "portal-do-aluno",
    meta: {
      title: "Portal do Aluno"
    },
    component: () =>
      import("../src/views/PortalDoAluno.vue")
  },  
  {
    path: "/comunicados",
    name: "comunicados",
    meta: {
      title: "Comunicados"
    },
    component: () =>
      import("../src/views/Comunicados.vue")
  },
  {
    path: "/revista",
    name: "revista",
    meta: {
      title: "Revista"
    },
    component: () =>
      import("../src/views/RevistaAlfa.vue")
  }
  ];


  const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
      return { x: 0, y: 0 };
      /*  if (pageNotScroll.includes(to.name)) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }*/
    }
  });

  router.beforeEach((to, from, next) => {
    document.title =
      process.env.VUE_APP_HOST == "DEV" ? "[DEV] ALFAMÉRICA - A FACULDADE QUE VOCÊ PROCURA" : "ALFAMÉRICA - A FACULDADE QUE VOCÊ PROCURA";
    if (to.meta.title) document.title = to.meta.title + " - ALFAMÉRICA - A FACULDADE QUE VOCÊ PROCURA";
    next();
  });
  
export default router
